module.exports = { id: "linkedin", url: "/build/app/img/symbols.svg#linkedin", viewBox: "", toString: function() { return this.url; } };